module.exports = __webpack_public_path__ + "img/index-security-bottom1.b2552abb.png";